import React from 'react';

import classNames from 'classnames';
import {Container} from 'reactstrap';
import {useParams} from 'react-router';

import {COMPANY_STATUSES, VIEWPORT_WIDTHS} from 'configs';
import {ENABLE_CB_CONTACT_US} from 'configs/enable-features';
import {useViewport} from 'contexts/ViewportContext';

import CBHelmet from './CBHelmet';
import CBHero from './CBHero';
import CBDescription from './CBDescription';
import CBAccreditationScope from './CBAccreditationScope';
import CBParticipationStatus from './CBParticipationStatus';
import CBContact from './CBContact';

import useGetCB from './useGetCB';
import {useAuth} from 'contexts/AuthContext';

import {get} from 'lodash';
import styles from './styles.module.scss';

function CertificationBody() {
  const cbProps = useGetCB();
  const {isAuth, isMainAccount, account} = useAuth();
  const {size} = useViewport();
  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS.xl;
  const isCompanySuspended =
    get(account, 'company.company_status') === COMPANY_STATUSES.suspended;

  const {cbId} = useParams();

  return (
    <Container className={classNames(isMobile ? 'px-3 py-0' : 'p-0')}>
      <CBHelmet {...cbProps} />

      <div className={styles['header']}>Certification Body</div>
      <hr className={styles['hr--thickness-two']} />

      <CBHero {...cbProps} />
      <hr className={styles['hr--thickness-one']} />

      <CBDescription {...cbProps} />
      <hr className={styles['hr--thickness-one']} />

      <CBParticipationStatus {...cbProps} />
      <hr className={styles['hr--thickness-one']} />

      <CBAccreditationScope />

      {ENABLE_CB_CONTACT_US &&
        (isAuth && isMainAccount ? !isCompanySuspended : true) && (
          <>
            <hr className={styles['hr--thickness-one']} />

            <CBContact cbId={cbId} />
          </>
        )}
    </Container>
  );
}

export default CertificationBody;
